export default __webpack_public_path__ + "static/media/cleanliness.3fe0692f.svg";